import React, { Component } from 'react';
import './App.css';
import Select from 'react-select';

const options = 'abcdefghijklmnop'.split('').map(letter => ({label: letter, value: letter}));

class App extends Component {
  render() {
    return (
      <div className="App">
        <Select
          options={options}
          openMenuOnFocus
        />
      </div>
    );
  }
}

export default App;
